<template>
  <div>
    <ModalBanner :modalActive="modalBannerActive" :modalImages="images" :slideIndex="slideIndex" :show-text="true" @update:close="modalBannerActive = $event"> </ModalBanner>
    <div class="overflow-hidden relative h-400 flex items-end justify-center">
      <template v-if="domain !== 'agentpreview'">
        <div class="mask-banner hand" @click.prevent="toggleModalBanner(0)"></div>
        <SectionHeaderTrip
          :breadcrumbs="dataTrip.breadcrumb"
          :images-length="images.length"
          :count-traveller="designer?.total_traveller_booking"
          :name-designer="designer?.name"
          :rating="designer?.rating"
          :count-review="designer?.number_of_reviews"
          @view-all-images="toggleModalBanner(0)"
          @share="$emit('share')"
          @download="$emit('download')"
        />
        <div class="banner absolute top-0 bottom-0 left-0 right-0">
          <div class="img img-1 relative">
            <BaseResponsiveImages :src="dataTrip.featured_image[0]" :alt="dataTrip.name" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="banner" :class="[imgHeight, dataTrip.featured_image.length > 2 && $device.isDesktopOrTablet ? 'grid' : '']">
          <div class="img img-1 relative">
            <div class="el-cover hand" @click="toggleModalBanner(0)">
              <BaseResponsiveImages :src="dataTrip.featured_image[0]" :alt="dataTrip.name" />
            </div>
          </div>
          <div class="img img-2 relative" v-if="$device.isDesktopOrTablet && dataTrip.featured_image[1]">
            <div class="el-cover hand" @click="toggleModalBanner(1)">
              <BaseResponsiveImages :src="dataTrip.featured_image[1]" :alt="dataTrip.name" />
            </div>
          </div>
          <div class="img img-3 relative" v-if="$device.isDesktopOrTablet && dataTrip.featured_image[2]">
            <div class="el-cover hand" @click="toggleModalBanner(2)">
              <BaseResponsiveImages :src="dataTrip.featured_image[2]" :alt="dataTrip.name" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import Badge from '~/components/ui/badge/Badge'
import BaseResponsiveImages from '~/components/ui/BaseResponsiveImages/BaseResponsiveImages'
import AppModal from '~/components/ui/modal/AppModal'
import { isEmpty, publicDomain } from '~/helper'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import { debounceHeapTracking } from '~/mixins/heap'
import ModalBanner from './ModalBanner'
import SectionHeaderTrip from './SectionHeaderTrip.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

export default {
  components: {
    BaseResponsiveImages,
    ModalBanner,
    Badge,
    AppModal,
    SectionHeaderTrip,
  },
  emits: ['share', 'download'],
  setup() {
    const domain = publicDomain()
    const modalBannerActive = ref(false)
    const slideIndex = ref(0)
    const tripPlanStore = useTripPlanStore()
    
    const dataTrip = computed(() => tripPlanStore.dataTrip)
    const designer = computed(() => tripPlanStore.designer)
    const images = computed(() => {
      if (isEmpty(dataTrip.value)) return []
      return dataTrip.value.images.concat(dataTrip.value.product_banners)
    })

    const toggleModalBanner = (index) => {
      slideIndex.value = index
      modalBannerActive.value = !modalBannerActive.value
      debounceHeapTracking('See all Trip Plan Photos', {
        number_of_photos: images.value?.length,
      })
      debounceAmplitudeScriptTracking('See all Trip Plan Photos', {
        number_of_photos: images.value?.length,
      })
    }

    return {
      dataTrip,
      designer,
      images,
      toggleModalBanner,
      modalBannerActive,
      slideIndex,
      domain,
    }
  },
}
</script>

<style lang="scss" scoped>
.modalContent {
  :deep(div) {
    * {
      font-size: 16px;
      line-height: 24px !important;
    }

    a {
      text-decoration: underline !important;
      color: black;
    }
  }

  > div:first-child {
    margin-bottom: 30px;
  }
}
//.button-glass {
//  position: absolute;
//  bottom: 12px;
//  right: 12px;
//  background: rgba(0, 0, 0, 0.3);
//  backdrop-filter: blur(10px);
//}
.banner {
  max-width: 100vw;
  width: 100%;
  &:not(.grid) {
    .img {
      width: 100%;
      height: 100%;
    }
  }
  &.grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-flow: dense;
    grid-auto-rows: 12;
    grid-gap: 12px;
    .img {
      &.img-1 {
        grid-column: span 9;
        grid-row: span 2;
      }
      &.img-2,
      &.img-3 {
        grid-column: span 3;
        grid-row: span 1;
      }
    }
  }
}
.mask-banner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: linear-gradient(180deg, rgba(10, 10, 10, 0) 0%, rgba(10, 10, 10, 0.12) 33.87%, rgba(10, 10, 10, 0.44) 64.87%, rgba(10, 10, 10, 0.75) 100%);
  @include phone {
    background: linear-gradient(180deg, rgba(10, 10, 10, 0.25) 0%, rgba(10, 10, 10, 0.12) 40.87%, rgba(10, 10, 10, 0.44) 55.87%, rgba(10, 10, 10, 0.75) 76.87%);
  }
}
</style>
